export default __webpack_public_path__ + "static/media/icons8-map-marker.9c4236ca.svg";